import React, { useEffect, useState } from 'react';
import { Drawer } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import moment from 'moment/moment';
import { getScheduleDetailsByIdService } from '../../../../../services/customer/scheduleServices';

function ScheduleDetailsDrawer({ show, setShow, stationsMap }) {
  const [scheduleDetails, setScheduleDetails] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const res = await getScheduleDetailsByIdService(show?.rideId);
      res?.sort(
        (a, b) => a.index - b.index,
      );
      setScheduleDetails(res?.filter((stop) => stop?.isStandingStation));
    };
    if (show?.rideId && !scheduleDetails) {
      fetchData();
    }
  }, [show]);

  return (
    <Drawer
      open={show}
      onClose={() => setShow(false)}
      placement="left"
      width="100%"
      headerStyle={{
        display: 'none',
      }}
      style={{
        height: '100%',
        width: '100%',
      }}
    >
      <div className="flex flex-col gap-5">
        <div className="flex justify-between items-center">
          <ArrowLeftOutlined
            style={{
              fontSize: '24px',
              cursor: 'pointer',
              color: 'red',
            }}
            onClick={() => setShow(false)}
          />
          <p className="font-big-bold text-primary m-0 text-[20px] capitalize">
            {stationsMap?.get(show?.startStation?.code) || show?.startStation?.name}
            {' '}
            -
            {' '}
            {stationsMap?.get(show?.endStation?.code) || show?.endStation?.name}
          </p>
          <div className="w-6" />
        </div>
        <div className="flex flex-col gap-4">
          {scheduleDetails?.map((stop, index) => (
            <React.Fragment
              key={stop?.id}
            >
              <div className="flex justify-between items-center">
                <p
                  className="text-base m-0 whitespace-nowrap font-big-bold capitalize"
                >
                  {stationsMap.get(stop?.station?.code) || stop?.station?.name}
                </p>
                <p
                  className="text-base m-0 whitespace-nowrap text-primary"
                >
                  {
                    moment(stop?.arrivalDateTime).format('HH:mm')
                  }
                </p>
              </div>
              {index + 1 < scheduleDetails?.length && <div className="h-[1px] w-full bg-black/30" />}
            </React.Fragment>
          ))}
        </div>
      </div>
    </Drawer>
  );
}

export default ScheduleDetailsDrawer;
